module.exports = __webpack_public_path__ + "img/green-rec.2e7ed08e.svg";